/*
 * @Author: 曹捷
 * @Date: 2021-10-27 15:04:01
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-11 15:48:50
 * @Description: 菜单  路由跳转 公共逻辑
 */
import { pushState } from './history'
export default function () {
  return {
    /**
     * 获取当前路由 所有上级
     * @param {*} store 
     * @param {*} route 
     * @returns 
     */
    getRouteList (store, route) {
      let config = store.state.settings
      let menuList = store.state.permission.menuList
      let arr = []
      let pathname = window.location.pathname
      // 父节点 ，没有实际的路由地址，需要判断是否是有子节点
      // let currInfo = menuList.find(ele => {
      //   return ele[config.menu.url].indexOf(route.path + '/') !== -1
      // })
      let currInfo = menuList.find(ele => {
        return ele[config.menu.url] === pathname
      })
      function getPInfo (currInfo) {
        let item = menuList.find(ele => ele[config.menu.id] === currInfo[config.menu.parentId])
        if (item) {
          arr.push(item[config.menu.key])
          getPInfo(item)
        }
      }
      if (currInfo) getPInfo(currInfo)
      return arr
    },
    /**
     * 去控制台  打开第一个应用
     */
    toCenterController (store) {
      let config = store.state.settings
      let menuList = store.state.permission.sysMenu
      function getFirstMenu (list) {
        if (list[0].children && list[0].children.length > 0) {
          return getFirstMenu(list[0].children)
        } else {
          return list[0]
        }
      }
      if (menuList && menuList.length > 0) {
        let menu = getFirstMenu(menuList)
        pushState(menu[config.menu.url])
      } else {
        console.error(`提示： 当前用户暂未开通服务 服务列表为空`)
      }
    }
  }
}